export const QUERY_KEY = {
  cloudSignInfo: ['cloudSignInfo'],
  medicalConsultationActiveStep: ['medicalConsultationActiveStep']
};

export const STORAGE_KEYS = {
  QUERY_STRING: 'queryStrings'
};
